import PropTypes from "prop-types";
import { sizes } from "./types";
export var sizePropType = PropTypes.oneOf(sizes);